import { Wrapper } from "../../Views/CommonStyles";
import Row from "../../Shared/Kit/Row";
import Header from "../../Shared/Header";
import Section1 from "../../Views/Notifications/Section1";

const Notifications = () => {
  return (
    <Wrapper>
      <Header headerColor={"white"} />
      <Row className="content">
        <Row className="section">
          <Section1 />
        </Row>
      </Row>
    </Wrapper>
  );
};

export default Notifications;